import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import { useIsMobile } from '../../style/constants';
import { TextWithGradient } from '../../VuexyDesign/atoms/Text';
import { Col, Row, Badge } from '../../VuexyDesign/atoms/_index';
import DistributionButton from './DistributionButton';

function DistributionLandingPageSteps({
  title,
  secondTitle,
  desc,
  imgUrl,
  isSecondary,
  isComingSoon,
  buttonText,
}: StepProps) {
  const isMobile = useIsMobile();

  return (
    <>
      {isMobile ? (
        <StepMobile
          title={title}
          secondTitle={secondTitle}
          desc={desc}
          imgUrl={imgUrl}
          isSecondary={isSecondary}
          isComingSoon={isComingSoon}
          buttonText={buttonText}
        />
      ) : (
        <StepDesktop
          title={title}
          secondTitle={secondTitle}
          desc={desc}
          imgUrl={imgUrl}
          isSecondary={isSecondary}
          isComingSoon={isComingSoon}
          buttonText={buttonText}
        />
      )}
    </>
  );
}

const StepDesktop = ({
  title,
  secondTitle,
  desc,
  imgUrl,
  isSecondary,
  isComingSoon,
  buttonText,
}: StepProps) => {
  const { t } = useTranslation('organisms');

  const getButton = () => (
    <DistributionButton type="GRADIENT_OUTLINE" text={buttonText[1]} />
  );

  return (
    <Row
      className={`mt-3 mx-auto ${
        isSecondary ? 'flex-row-reverse' : 'flex-row'
      } align-items-center mb-5 w-75`}
    >
      <Col
        sm={6}
        className={`${
          isSecondary
            ? 'pr-md-0 text-center text-md-right'
            : 'pl-md-0 text-center text-md-left'
        } pl-0 pr-0`}
      >
        <Image
          src={imgUrl}
          priority
          width={528}
          height={264}
          objectFit="contain"
          className="pointer-events-none"
          alt="img-steps"
          style={{
            maxWidth: '100%',

            objectFit: 'contain',
          }}
        />
      </Col>
      <Col
        sm={6}
        className={`${
          isSecondary ? 'pr-md-4' : 'pl-md-4'
        } pl-0 pr-0 mt-1 mb-mt-0`}
      >
        <div>
          <TextWithGradient>{title}</TextWithGradient>
          {isComingSoon && (
            <Badge
              text={t('organisms:comingSoon')}
              color="warning"
              className="text-white ml-1"
            />
          )}
        </div>

        <h3 className="custom-heading-font-3">{secondTitle}</h3>
        <p>{desc}</p>
        {getButton()}
      </Col>
    </Row>
  );
};

const StepMobile = ({
  title,
  secondTitle,
  desc,
  imgUrl,
  isSecondary,
  isComingSoon,
  buttonText,
}: StepProps) => {
  const { t } = useTranslation('organisms');

  const getButton = () => (
    <DistributionButton type="GRADIENT_OUTLINE" text={buttonText[1]} />
  );

  return (
    <>
      <Row
        className={`mt-2 mx-auto text-center ${
          isSecondary ? 'flex-row-reverse' : 'flex-row'
        } align-items-center mb-5 w-100`}
      >
        <Col
          xs={12}
          className={`${
            isSecondary ? 'pr-md-4' : 'pl-md-4'
          } pl-0 pr-0 mt-1 mb-mt-0`}
        >
          <Image
            src={imgUrl}
            priority
            width="365"
            height="178"
            objectFit="contain"
            className="pointer-events-none br-5"
            alt="img-steps"
            style={{
              maxWidth: '100%',

              objectFit: 'contain',
            }}
          />
        </Col>
        <Col xs={12} className={`${'text-center'} pl-0 pr-0`}>
          <div className="mt-2">
            <TextWithGradient className=" d-flex justify-content-center mb-1">
              {title}
            </TextWithGradient>
            {isComingSoon && (
              <Badge
                text={t('organisms:comingSoon')}
                color="warning"
                className="text-white ml-1"
              />
            )}
          </div>
          <h3 className="custom-heading-font-3 text-center d-flex justify-content-center">
            {secondTitle}
          </h3>
        </Col>

        <Col
          xs={12}
          className={` ${
            isSecondary ? 'pr-md-4' : 'pl-md-4'
          } pl-0 pr-0 mt-1 mb-mt-0`}
        >
          <p>{desc}</p>
          <div className="d-flex justify-content-center mt-1">
            {getButton()}
          </div>
        </Col>
      </Row>
      <div className="w-100 mt-2 mb-3">
        <hr />
      </div>
    </>
  );
};

interface StepProps {
  title: string;
  secondTitle: string;
  desc: string;
  imgUrl: string;
  isSecondary?: boolean;
  isComingSoon?: boolean;
  buttonText: string[];
}

export default DistributionLandingPageSteps;
